import { createFileRoute } from '@tanstack/react-router';

import { MessagingLogsPage } from '@/features/messaging/components/messaging-logs-view';

export const Route = createFileRoute('/_app/correo/logs/')({
  component: MessagingLogsPage,
});
